"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Checkbox = void 0;
var SwitchBase_1 = __importDefault(require("../internal/SwitchBase"));
var Checkbox_1 = require("./Checkbox");
var Checkbox = Object.assign(Checkbox_1.Checkbox, {
    Icon: SwitchBase_1["default"].Icon,
    Label: SwitchBase_1["default"].Label
});
exports.Checkbox = Checkbox;
//# sourceMappingURL=index.js.map